// hospital.service.ts

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HospitalService {

  private hospitalSource = new BehaviorSubject<any>(
    JSON.parse(localStorage.getItem('SelectedHospital') || 'null')
  );

  currentHospital = this.hospitalSource.asObservable();

  constructor() { }

  changeHospital(hospital: any) {
    localStorage.setItem('SelectedHospital', JSON.stringify(hospital));
    localStorage.setItem('HospitalId', hospital.hos_Id);
    this.hospitalSource.next(hospital);
  }

  getHospital() {
    return JSON.parse(localStorage.getItem('SelectedHospital') || 'null');
  }

}